import type { OfferData } from 'service/offer/model';
import type { UserData } from 'service/user/model';

export function getMainEmail(user: UserData) {
	return (
		(user.emails?.find((email) => !email.isDeleted && email.verified)?.email || user?.emails?.at(-1)?.email) ?? ''
	);
}

export function cacheKeyPostfixByUser(headers?: Headers) {
	return headers
		? getUserSession(headers)
		: globalThis.document.cookie
			? getDsCookie(globalThis.document.cookie)
			: undefined;
}

export function getDsCookie(cookieString?: null | string) {
	return cookieString
		?.split(';')
		.find((c) => c.includes('ds='))
		?.split('=')[1];
}

export function getUserSession(headers: Headers) {
	return getDsCookie(headers.get('Cookie'));
}

export function hasUserSession(headers: Headers) {
	return headers.get('Cookie')?.includes('ds=');
}

export function isOfferOwnedBy(offer: OfferData, user: UserData | null): boolean {
	return !!(user && user.id === offer.user?.id);
}

export function isRegisteredViaPhone(user: UserData): boolean {
	return !user.login;
}

export function isUserDisabled(user: UserData | null): boolean {
	if (!user) return false;

	return user.enabled === false || user.userService?.serviceEnabled === false;
}
